import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { usePermission } from '../../hooks/usePermission';
import { FETCH_SUB_ACCOUNT } from './subAccount.query';

export function SubAccountBreadcrumb() {
  const { t } = useTranslation();
  const canReadClientLowRiskPii = usePermission('read:client_low_risk_pii');
  const canReadBillingSchedule = usePermission('read:billing_schedule');
  const canReadFeeTier = usePermission('read:fee_tier');
  const { data } = useQuery(
    FETCH_SUB_ACCOUNT({
      canReadClientLowRiskPii,
      canReadBillingSchedule,
      canReadFeeTier,
    }),
    {
      variables: { id: useParams().subAccountId },
    },
  );
  const goalName = data?.fetchSubAccount?.subAccount?.goal?.name;
  const subAccountName = `${goalName ?? ''} ${goalName ? '-' : ''} ${t(`accountTypes:${data?.fetchSubAccount?.subAccount?.account.type}`)}`;

  return data ? subAccountName : t('client:subAccount');
}
